// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { ImageLargeFragmentDoc } from '../imageLarge.fragment.generated';
import { LinkFragmentDoc } from '../index.generated';
export const ComponentFullWidthImageFragmentDoc = gql`
    fragment componentFullWidthImage on ComponentFullWidthImage {
  width
  image {
    ...imageLarge
  }
  link {
    ...link
  }
}
    ${ImageLargeFragmentDoc}
${LinkFragmentDoc}`;